import React, { useState } from 'react';

const CreateAliasDialog = ({ show, customerId, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    fieldKey: '',
    originalValue: '',
    replacementValue: ''
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fieldKey.trim()) {
      newErrors.fieldKey = 'Field key is required';
    }

    if (!formData.originalValue.trim()) {
      newErrors.originalValue = 'Original value is required';
    }

    if (!formData.replacementValue.trim()) {
      newErrors.replacementValue = 'Replacement value is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setSaving(true);
      await onSave({
        customerId,
        ...formData
      });
      // Reset form
      setFormData({
        fieldKey: '',
        originalValue: '',
        replacementValue: ''
      });
      setErrors({});
    } catch (err) {
      console.error('Error saving alias:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      fieldKey: '',
      originalValue: '',
      replacementValue: ''
    });
    setErrors({});
    onCancel();
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Manual Alias</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={handleCancel}
                disabled={saving}
              ></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="fieldKey" className="form-label">
                    Field Key <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="fieldKey"
                    name="fieldKey"
                    className={`form-control ${errors.fieldKey ? 'is-invalid' : ''}`}
                    value={formData.fieldKey}
                    onChange={handleChange}
                    placeholder="Enter the field name (e.g., vendor_name, media_type)"
                    disabled={saving}
                  />
                  {errors.fieldKey && (
                    <div className="invalid-feedback">{errors.fieldKey}</div>
                  )}
                  <div className="form-text">
                    The field name in the extracted data where this alias applies
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="originalValue" className="form-label">
                    Original Value <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="originalValue"
                    name="originalValue"
                    className={`form-control ${errors.originalValue ? 'is-invalid' : ''}`}
                    value={formData.originalValue}
                    onChange={handleChange}
                    placeholder="Enter the value as it appears in extracted data"
                    disabled={saving}
                  />
                  {errors.originalValue && (
                    <div className="invalid-feedback">{errors.originalValue}</div>
                  )}
                  <div className="form-text">
                    The value that appears in extracted invoice data
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="replacementValue" className="form-label">
                    Replacement Value <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="replacementValue"
                    name="replacementValue"
                    className={`form-control ${errors.replacementValue ? 'is-invalid' : ''}`}
                    value={formData.replacementValue}
                    onChange={handleChange}
                    placeholder="Enter the standardized replacement value"
                    disabled={saving}
                  />
                  {errors.replacementValue && (
                    <div className="invalid-feedback">{errors.replacementValue}</div>
                  )}
                  <div className="form-text">
                    The standardized value that should replace the original value
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={handleCancel}
                  disabled={saving}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={saving}
                >
                  {saving ? 'Creating...' : 'Create Alias'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default CreateAliasDialog;
